import Vue from "vue";
import validatePop from "@/plugins/validatePop.js";
const vm = new Vue();

export const checkMemberCod = async (tel, cardId) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .post(
        vm.$API_URL + "/member/fetch",
        {
          card_id: cardId,
          tel: tel,
        },
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        let data = res.data.data;
        let checkError = validatePop(res);
        if (!checkError.status) {
          reject(checkError);
        }
        resolve(data);
      });
  });
};

export const getIcon = async (courierIcon, typeIcon) => {
  return new Promise((resolve, reject) => {
    let icon = courierIcon ? courierIcon : (vm.$THEME.name == 'shippop') ? "default_courier_shippop.svg" :"default_courier.svg";

    if( vm.$THEME.name == 'poststation' ){
        if( icon == 'EMSXP.png' ){
            icon = 'THP.png'
        }else if( icon == 'PRE_EMSXP.png' ){
            icon = 'PRE_THP.png'
        }
    }

    const path =
      typeIcon && typeIcon === "service"
        ? `/icon/additional_service/${icon}`
        : `/icon/${icon}`;

    if (icon == "shippop-logo") {
      resolve("/img/brand/logo-shippop.png");
    } else {
      const storageRef = vm.$firebase
        .storage()
        .ref(path)
        .getDownloadURL();
      storageRef
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve("/img/brand/load-error.svg");
        });
    }
  });
};

export const sendErrorToLine = (res) => {
  vm.$http.post(
    vm.$API_URL + "/lineNotify/error",
    {
      error: res,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Token: localStorage.getItem("access_token"),
      },
    }
  );
};

export const getLabelHtml = (orderId, size, orderDetailId) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .get(vm.$API_URL + `/order/${orderId}/label/${size}/${orderDetailId}`, {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        resolve(res.data.data);
      });
  });
};

export const cancelOrderByOne = (orderId, orderDetailId) => {
  return new Promise((resolve, reject) => {
    if (!orderId) {
      resolve("newbill");
    } else {
      vm.$http
        .delete(vm.$API_URL + `/shop/order/${orderId}`, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
          data: {
            list_cancel: orderDetailId,
            remark: "ยกเลิกรายการจากหน้า POS",
          },
        })
        .then((res) => {
          resolve(res.data);
        });
    }
  });
};

export const getLabelHtmlByTracking = (size, tracking , dropoff_type) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .get(vm.$API_URL + `/shippop/labels`, {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
        params: {
          size: size,
          tracking_codes: tracking,
          dropoff_type: dropoff_type
        },
      })
      .then((res) => {
        resolve(res.data.data);
      });
  });
};

export const checkStatusOrder = (orderId) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get(vm.$API_URL + `/status/order/${orderId}`, {
            headers: {
                Token: localStorage.getItem("access_token"),
            },
        })
        .then((res) => {
            resolve(res.data.data);
        });
    });
  };

export const getSizeBox = () => {
    return new Promise((resolve, reject) => {
        vm.$http
        .get(vm.$API_URL + `/courierBoxSize`, {
            headers: {
                Token: localStorage.getItem("access_token"),
            }
        })
        .then((res) => {
            resolve(res.data.data);
        });
    });
};

export const getCourierCheckPrice = ( tmpCheckPrice ) => {
    return new Promise((resolve, reject) => {
        vm.$http
            .post(
                vm.$API_URL + "/shop/checkCourierPrice",
                {
                    weight: tmpCheckPrice.weight * (vm.$THEME.unitKG?1000:1),
                    width: (tmpCheckPrice.dimension.width) ? tmpCheckPrice.dimension.width : '1',
                    length: (tmpCheckPrice.dimension.length) ? tmpCheckPrice.dimension.length : '1',
                    height: (tmpCheckPrice.dimension.height) ? tmpCheckPrice.dimension.height : '1',
                    box_size: (tmpCheckPrice.dimension.size.boxSize) ? tmpCheckPrice.dimension.size.boxSize : '0',
                    from: tmpCheckPrice.fromAddress,
                    to: tmpCheckPrice.toAddress
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token"),
                    },
                }
            )
            .then((res) => {
                let data = res.data.data;
                if (!res.data.status) {
                    if (res.data.error.hasOwnProperty("notices")) {
                        reject(
                            "กรุณากรอกข้อมูลให้ครบถ้วน"
                        );
                    } else {
                        reject(res.data.error.message);
                    }
                }
                resolve(data);
            });
    });
}

export const getCourierCheckPriceV2 = ( bookingItems ) => {
  return new Promise((resolve, reject) => {

      bookingItems.forEach( (item , index) => {
        item.parcel.weight = item.parcel.weight * (vm.$THEME.unitKG?1000:1),
        item.parcel.width = item.parcel.width ? item.parcel.width : '1',
        item.parcel.length = item.parcel.length ? item.parcel.length : '1',
        item.parcel.height = item.parcel.height ? item.parcel.height : '1',
        item.parcel.box_size = item.parcel.box_size ? item.parcel.box_size : '0'
      })

      vm.$http
          .post(
              vm.$API_URL + "/shop/v2/checkCourierPrice",
              {
                  data: bookingItems
              },
              {
                  headers: {
                      Token: localStorage.getItem("access_token"),
                  },
              }
          )
          .then((res) => {
              let data = res.data.data;
              if (!res.data.status) {
                  if (res.data.error.hasOwnProperty("notices")) {
                      reject(
                          "กรุณากรอกข้อมูลให้ครบถ้วน"
                      );
                  } else {
                      reject(res.data.error.message);
                  }
              }
              resolve(data);
          });
  });
}

